import { Component, OnInit } from '@angular/core';
import { IProcessingReassuranceLabels } from "app_sasha/shared/components/processing-reassurance/processing-reassurance.component";
import { Yii } from "libraries/interfaces/Yii";
import { ActivatedRoute, Data, Params, Router } from "@angular/router";
import { Observable } from "rxjs";
import { BookingSearchParameters } from "app_sasha/shared/models/BookingSearchParameters";
import { SashaBreadcrumbService } from "app_sasha/shared/components/breadcrumb/sasha-breadcrumb.service";
import { ICreateProcessingResponse, IProcessingParameter } from "libraries/service/resources/model/processing/ICreateProcessing";
import { ProcessingService } from "libraries/service/processing/processing.service";
import { IBookingSearchParametersURL } from "libraries/interfaces/IBookingSearchParameters";
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { BookingType } from 'libraries/service/resources/booking/interfaces/get-bookings.enum';

@Component({
    selector: 'processing-qualityCheck',
    template: `
    <processing-reassurance [wordings]="labels"
                            [processableBookings]="processableBookings"
                            [notProcessableBookings]="notProcessableBookings"
                            [loading]="loading"
                            [errorMsg]="errorMsg"
                            (onProcessing)="qualityCheckBookings($event)"></processing-reassurance>
  `,
    styles: []
})
export class ProcessingQualityCheckComponent implements OnInit {

    public processableBookings: IGetBookingsCommonResponse[];
    public notProcessableBookings: IGetBookingsCommonResponse[];

    public loading: boolean;
    public errorMsg: string;

    public readonly labels: IProcessingReassuranceLabels = {
        processBookings: Yii.t('wui-sasha-js', "Vérifier les dossiers"),

        processableBookingsIsEmpty: Yii.t('wui-sasha-js', "Aucun dossier vérifiable"),
        processableBooking: Yii.t('wui-sasha-js', "dossier vérifiable"),
        processableBookings: Yii.t('wui-sasha-js', "dossiers vérifiables"),

        notProcessableBookingsIsEmpty: Yii.t('wui-sasha-js', "Aucun dossier non-vérifiable"),
        notProcessableBooking: Yii.t('wui-sasha-js', "dossier non-vérifiable"),
        notProcessableBookings: Yii.t('wui-sasha-js', "dossiers non-vérifiables"),

        notProcessableReasons: {
            main: Yii.t('wui-sasha-js', "Les dossiers ne sont pas vérifiables pour au moins une des raisons suivantes :"),
            reasons: [
                Yii.t('wui-sasha-js', "Il ne s'agit pas d'un dossier aérien"),
            ]
        },

        dialog: {
            title: Yii.t('wui-sasha-js', 'Vérification des dossiers'),
            question: Yii.t('wui-sasha-js', 'Voulez-vous vérifier les dossiers ?'),
            cancel: Yii.t('wui-sasha-js', 'Abandonner'),
            accept: Yii.t('wui-sasha-js', 'Vérifier les dossiers sélectionnés'),
        },

        loaderMessage: Yii.t('wui-sasha-js', 'Vérification des dossiers en cours'),
    };

    constructor(private readonly processingService: ProcessingService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly sashaBreadcrumbService: SashaBreadcrumbService,
        private readonly router: Router,
        private readonly titleService: TitleService
    ) { }

    public ngOnInit(): void {
        const { params, data }: { params: Params, data: Observable<Data> } = this.activatedRoute;

        this.titleService.setTitle(Yii.t("wui-sasha-js", "Vérification de dossiers"));

        // init breadcrumb
        params.subscribe(
            (parameters: IBookingSearchParametersURL) => {
                this.sashaBreadcrumbService.setProcessingSearch(BookingSearchParameters.fromRouteParams(parameters));
                this.sashaBreadcrumbService.setQualityCheckItems();
            },
        );

        // init processable and notProcessable bookings lists
        data.subscribe(({ bookings }: { bookings: IGetBookingsCommonResponse[] }) => {
            this.processableBookings = bookings.filter(isAirBooking);
            this.notProcessableBookings = bookings.filter((booking: IGetBookingsCommonResponse): boolean => !isAirBooking(booking));
        });
    }

    public qualityCheckBookings(selectedBookings: IGetBookingsCommonResponse[]): void {
        this.loading = true;
        this.errorMsg = null;
        this.processingService
            .qualityCheckBooking(selectedBookings)
            .subscribe({
                next: async (response: ICreateProcessingResponse<IProcessingParameter>): Promise<void> => {
                    await this.router.navigate(['/sasha/processing/', response.id]);
                    this.loading = false;
                },
                error: (error: Error): void => {
                    this.errorMsg = error.message;
                    this.loading = false;
                }
            });
    }
}

function isAirBooking(booking: IGetBookingsCommonResponse): boolean {
    return booking.type && booking.type.includes(BookingType.air);
}
